module.exports = __webpack_public_path__ + "fonts/Outfit-ExtraLight.f257db45.ttf";